import { controls, currencyToNumber, grouped } from "../../controls";

const pcmc_employee_sal_stru = {
  label: "Employees salary structure Details",
  url: "pcmc_employee_sal_stru",
  pageLabel: "Employees salary structure Details",
  pageType: "history",
  filter: [
    ...controls.displayText({
      tab: "filter", label: "Employee",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "employee_code", controlType: "Employee", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({
      tab: "filter", label: "Employee Status",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "employment_status_code", controlType: "EmployeeStatus", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({
      tab: "filter", label: "Department",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "department_code", controlType: "Department", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),


    ...controls.displayText({
      tab: "filter", label: "Branch",
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "branch_code", controlType: "Branch", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    //    ...controls.magicDateLabel({ tab: "general", label: "From Date",target: "from_date"}),
    //    ...controls.magicDate({ tab: "general", name: "from_date", dateType: "ontype"}),
    //    ...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),

    //    ...controls.magicDateLabel({ tab: "general", label: "To Date",target: "to_date"}),
    //    ...controls.magicDate({ tab: "general", name: "to_date", dateType: "ontype"}),
    //  //  ...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Pcmc Employees Attendance Status Details",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },

    filterable: true,
    sortable: true,
    defaultsTo: 0,
    textReportProps: {
      '132': {
        filename: `Pcmc Employees Attendance Status Details-$pageData.as_on_date$.oro`,
        empty: true,//true
        format: {},
        header: "default",
        footer: "default"
      },
    },
    reportProps: { searchable: true, sortable: true },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }//3
      },

      {
        Header: "Employee Code",
        accessor: "employee_code",

      },
      {
        Header: "Employee Name",
        accessor: "employee_display",

      },

      {
        Header: "Department",
        accessor: "department_display",

      },
      {
        Header: "Designation",
        accessor: "designation_display"
      },
      {
        Header: "Fix Pay",
        accessor: "fix_pay",
        type: "currency",

      },

      {
        Header: "Basic",
        accessor: "basic",
        type: "currency",
      },
      {
        Header: "lp",
        accessor: "lp",
        type: "currency",

      },

      {
        Header: "gp",
        accessor: "grade_pay",
        type: "currency",
      },
      {
        Header: "wa",
        accessor: "wada",
        type: "currency",

      },
      {
        Header: "ot",
        accessor: "ot",
        type: "currency",
      },
      {
        Header: "da",
        accessor: "da",
        type: "currency",
      },
      {
        Header: "hra",
        accessor: "hra",
        type: "currency",

      },
      {
        Header: "Special Other",
        accessor: "special_other",
        type: "currency",

      },
      {
        Header: "Gross Pay",
        accessor: "gp",
        type: "currency",

      },
      {
        Header: "PT",
        accessor: "prof_tax",
        type: "currency",
      },
      {
        Header: "GPF",
        accessor: "gpf",
        type: "currency",
      },
      {
        Header: "GIS",
        accessor: "gis",
        type: "currency",
      },
      {
        Header: "LIC",
        accessor: "lic",
        type: "currency",
      },
      {
        Header: "I/T",
        accessor: "it",
        type: "currency",
      },
      {
        Header: "Festival Advance",
        accessor: "festive_advance",
        type: "currency",
      },
      {
        Header: "Bank Loan",
        accessor: "bank_loan",
        type: "currency",
      },

      {
        Header: "m/c Loan",
        accessor: "mc_loan",
        type: "currency",
      },
      {
        Header: "Other Deduction",
        accessor: "other_deduction",
        type: "currency",
      },
      {
        Header: "Total Deduction",
        accessor: "total_deduction",
        type: "currency",
      },
      {
        Header: "Net Payable",
        accessor: "total",
        type: "currency",
      }


    ]
  }
};

export default pcmc_employee_sal_stru;